export default {"src":"/_next/static/media/spotify.c067b02d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};